import React from 'react'

// Update title to register page view with analytics
import useDocumentTitle from '../../Utilities/useDocumentTitle'

function Design() {
  useDocumentTitle('Experience - Design')
  return (
    <div className='experience-section my-4'>
      <h5 className='text-center'>Summary</h5>
      <p className='text-center'>
        In 2018, I had the opportunity to complete General Assembly's Web
        Development Immersive program, in support of my goal of transitioning
        away from law and into tech. Over the course of 12 weeks, I learned
        front end development technologies and frameworks including HTML, CSS,
        and JavaScript, as well as React (which I used to build this site). I
        also learned about APIs, and developed several full stack applications,
        which are all sadly gone now due to lack of maintenance.
      </p>
      <p className='text-center'>
        More recently, I've been focusing my learning on user experience and
        design, as it relates to my current position with WalkMe, but also more
        broadly as I look to refresh my rusty development skills and create some
        new sites and applications. I am currently working through Google's UX
        Design Professional Certificate via Coursera and reading several
        relevant books to supplement the coursework.
      </p>
      <p className='text-center'>
        As I complete artifacts to showcase my design abilities for the course,
        I will look to add them here!
      </p>
    </div>
  )
}

export default Design
